import { Button, Skeleton, Tooltip, Typography } from "@mui/material";
import { useSawBundlesByShift } from "../hooks/useSawBundlesByShift";

export const PendingCutsCount = ({ assetId }: { assetId: number }) => {
	const { data, isLoading, error, refetch } = useSawBundlesByShift(assetId);
	if (isLoading)
		return <Skeleton width={112} aria-label="Loading pending checks" />;
	if (error)
		return (
			<Button size="small" color="error" onClick={() => void refetch()}>
				Pending checks · Retry
			</Button>
		);
	return (
		<Tooltip title="Cuts in the current shift with no check, a partial check, or out of tolerance and waiting for Reclassify or Cutback">
			<Typography variant="body2" sx={{ fontVariantNumeric: "tabular-nums" }}>
				Pending checks:{" "}
				<strong>{data?.shift.ShiftId == null ? "—" : data.pendingCount}</strong>
			</Typography>
		</Tooltip>
	);
};
